import { DialogComponent } from '@theme/dialog';

/**
 * Size chart modal component with tabbed content and unit switching.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element
 * @property {HTMLButtonElement[]} tabButtons - Main tab buttons (Size Guide / How to Measure)
 * @property {HTMLElement[]} tabPanels - Main tab panels
 * @property {HTMLButtonElement[]} unitButtons - Unit toggle buttons (inches / centimeters)
 * @property {HTMLElement[]} unitPanels - Unit content panels
 *
 * @extends DialogComponent
 */
class SizeChartModal extends DialogComponent {
  /**
   * Switch between main tabs (Size Guide / How to Measure).
   *
   * @param {{ tab: string }} data - The tab identifier to switch to
   */
  switchTab({ tab }) {
    const { tabButtons, tabPanels } = this.refs;

    if (!tabButtons || !tabPanels) return;

    for (const button of tabButtons) {
      const isActive = button.dataset.tab === tab;
      button.classList.toggle('size-chart-modal__tab--active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    }

    for (const panel of tabPanels) {
      panel.hidden = panel.dataset.tab !== tab;
    }
  }

  /**
   * Switch unit within Size Guide tab (inches / centimeters).
   *
   * @param {{ unit: string }} data - The unit identifier to switch to
   */
  switchUnit({ unit }) {
    const { unitButtons, unitPanels } = this.refs;

    if (!unitButtons || !unitPanels) return;

    for (const button of unitButtons) {
      const isActive = button.dataset.unit === unit;
      button.classList.toggle('size-chart-modal__unit-button--active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    }

    for (const panel of unitPanels) {
      panel.hidden = panel.dataset.unit !== unit;
    }
  }
}

if (!customElements.get('size-chart-modal')) {
  customElements.define('size-chart-modal', SizeChartModal);
}
